<template>
  <v-container grid-list-xs wrap>
    <v-layout row justify-center>
      <v-dialog v-model="successModal" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">
            <v-title>You're almost there!</v-title>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <hr />
                <p>
                  We’ve got your application and just need to process a few
                  admin tasks before you can start sending orders through to us.
                  This process generally takes less than one business day.
                </p>
                <p>
                  Orders can still be started in Sign On Glass, however you will
                  unable to complete them until we give you the green light.
                </p>
                <p>
                  Once we have you up and running, a printed and signed copy of
                  your contract will be sent to you; so please retain this for
                  your records.
                </p>
                <p>
                  We ask that you complete Vonex Channel Partner training at
                  your earliest convenience:
                </p>
                <p>
                  Please click on this link
                  <a
                    href="https://vonex.mindflash.com/PublicCoursePage.aspx?c=2494854331"
                    target="blank"
                    >Vonex Channel Partner Training</a
                  >
                </p>
                <p>
                  You will need to log out, and then back in to realise your new
                  access rights, log out using the button on the top right of
                  this webpage, then log back in.
                </p>
                <p>Welcome to the team!</p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="logout">Dismiss</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-title color="secondary">Vonex Online Dealer Registration Form</v-title>

    <v-flex xs12>
      <v-title>Company Registration</v-title>
      <v-card>
        <v-layout row wrap class="ma-1">
          <v-flex xs6>
            <v-text-field
              v-model="registeredCompanyName"
              label="Registered Company Name"
              :error-messages="errors.collect('registeredCompanyName')"
              v-validate="'required'"
              data-vv-name="registeredCompanyName"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="tradingName"
              label="Trading Name"
              :error-messages="errors.collect('tradingName')"
              v-validate="'required'"
              data-vv-name="tradingName"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="abn"
              label="ABN"
              :error-messages="errors.collect('abn')"
              v-validate="'required'"
              data-vv-name="abn"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-title>Address</v-title>
      <v-card>
        <v-layout row wrap class="ma-1">
          <!-- <vuetify-google-autocomplete
            id="map"
            class="form-control"
            placeholder="Start typing"
            :country="['au']"
            @placechanged="getAddressData"
          ></vuetify-google-autocomplete>-->

          <v-flex xs4>
            <v-text-field
              v-model="address"
              label="Address"
              :error-messages="errors.collect('address')"
              v-validate="'required'"
              data-vv-name="address"
              required
              hint="Street Address"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="city"
              label="City"
              :error-messages="errors.collect('city')"
              v-validate="'required'"
              data-vv-name="city"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              v-model="state"
              label="State"
              :error-messages="errors.collect('state')"
              v-validate="'required'"
              data-vv-name="state"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              type="number"
              v-model="postcode"
              label="PostCode"
              :error-messages="errors.collect('postcode')"
              v-validate="'required'"
              data-vv-name="postcode"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-title>Director Details</v-title>
      <v-card>
        <v-layout row wrap class="ma-1">
          <v-flex xs3>
            <v-text-field
              type="number"
              v-model="yrsEstablished"
              label="Years Established"
              :error-messages="errors.collect('yrsEstablished')"
              v-validate="'required|numeric'"
              data-vv-name="yrsEstablished"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="directorsName"
              label="Director's Name"
              :error-messages="errors.collect('directorsName')"
              v-validate="'required'"
              data-vv-name="directorsName"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="driversLicense"
              label="Drivers Licence Number"
              :error-messages="errors.collect('driversLicense')"
              v-validate="'required'"
              data-vv-name="driversLicense"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="telephoneNo"
              label="Telephone"
              :error-messages="errors.collect('telephoneNo')"
              v-validate="'required'"
              data-vv-name="telephoneNo"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="mobileNo"
              label="Mobile"
              :error-messages="errors.collect('mobileNo')"
              v-validate="'required|mobilenumber'"
              data-vv-name="mobileNo"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="email"
              label="Email"
              :error-messages="errors.collect('email')"
              v-validate="'required|email'"
              data-vv-name="email"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              name="numberSubAgents"
              label="Number of Sub Agents"
              v-model="numberSubAgents"
              :error-messages="errors.collect('numberSubAgents')"
              v-validate="'required'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12></v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="firstName"
              label="Contact First Name"
              :error-messages="errors.collect('firstName')"
              v-validate="'required'"
              data-vv-name="firstName"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="lastName"
              label="Contact Last Name"
              :error-messages="errors.collect('lastName')"
              v-validate="'required'"
              data-vv-name="lastName"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-title>Banking Details</v-title>
      <v-card>
        <v-layout row wrap class="ma-1">
          <v-flex xs6>
            <v-text-field
              v-model="bank"
              label="Bank"
              :error-messages="errors.collect('bank')"
              v-validate="'required'"
              data-vv-name="bank"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="accountName"
              label="Account Name"
              :error-messages="errors.collect('accountName')"
              v-validate="'required'"
              data-vv-name="accountName"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="accountNo"
              label="Account No"
              :error-messages="errors.collect('accountNo')"
              v-validate="'required'"
              data-vv-name="accountNo"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="bsbno"
              label="BSB"
              :error-messages="errors.collect('bsbno')"
              v-validate="'required'"
              data-vv-name="bsbno"
              mask="###-###"
              required
              return-masked-value
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="branchAddress"
              label="Branch Address"
              :error-messages="errors.collect('branchAddress')"
              v-validate="'required'"
              data-vv-name="branchAddress"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-checkbox
              v-model="approvedDealer"
              label="I agree to the terms and conditions as detailed in the Vonex Channel Partner agreement:"
              mandatory
              name="approvedDealer"
              @change="submit"
              :error-messages="errors.collect('approvedDealer')"
              v-validate="'required'"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-card v-if="approvedDealer && errors.items.length == 0">
      <v-title>Signature of Dealer</v-title>
      <v-card-text>
        <h2 v-if="isSubmitting">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular
          >Please wait - Contract being signed.
        </h2>
        <VueSignaturePad
          height="400px"
          saveType="image/png"
          ref="signaturePad"
        ></VueSignaturePad>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="save" color="primary">Sign and Submit</v-btn>
        <v-btn @click="undo" color="primary">Undo</v-btn>
      </v-card-actions>
      <message-alert :component="message"></message-alert>
    </v-card>

    <v-btn
      v-if="1 == 2 && approvedDealer"
      color="success"
      @click="getPDF(dealerId)"
      >getPDF</v-btn
    >
  </v-container>
</template>

<script>
import VueSignaturePad from "vue-signature-pad";

import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOutputActions } = createNamespacedHelpers(
  `register/output`
);
const { mapActions: mapRegisterActions } = createNamespacedHelpers(`register`);

const { mapActions: mapAuthActions } = createNamespacedHelpers(`orders/auth`);
import { mapRegisterFields } from "@/store/modules/register";

import { mapDealerFields } from "@/store/modules/orders";

import { mapOutputFields } from "@/store/modules/register/output";
const { mapActions: mapAddressActions } = createNamespacedHelpers(
  `orders/address`
);
export default {
  name: "dealer-register",
  components: {
    "signature-pad": VueSignaturePad,
  },
  data() {
    return {
      successModal: false,
      search: null,
      isLoading: false,
      entries: [],
      isSubmitting: false,
    };
  },
  methods: {
    ...mapOutputActions(["getPDF"]),
    ...mapAuthActions(["clearSession"]),
    ...mapAddressActions(["searchAddress", "completeAddress"]),
    ...mapRegisterActions(["getRegistered", "saveRegistered"]),
    openItem: (link) => {
      if (link.includes("http")) window.open(link, "_blank");
      else window.open("https://www.vonex.com.au/" + link, "_blank");
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    logout() {
      let vm = this;
      this.$auth.logout().then(() => {
        vm.clearSession().then((window.location.pathname = "/"));
      });
    },
    save() {
      let vm = this;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty && data.length > 6) {
        vm.isSubmitting = true;
        vm.approvedDealer = true;
        vm.electronicSignature = data;
        vm.saveRegistered()
          .then(() => {
            vm.isSubmitting = false;
            vm.successModal = true;
          })
          .catch(() => {
            vm.isSubmitting = false;
            vm.successModal = false;
          });
      }
    },
    submit(e) {
      let vm = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vm.approvedDealer = e;
        } else {
          vm.approvedDealer = e;
        }
      });
    },
    clear() {
      this.$validator.reset();
    },
    updateAddress(e) {
      let vm = this;
      vm.address = `${e.street_number} ${e.route}`;
      vm.city = e.locality;
      vm.state = e.administrative_area_level_1;
      vm.postcode = e.postal_code;
    },
    getAddressData: function(addressData) {
      this.updateAddress(addressData);
    },
  },
  computed: {
    ...mapDealerFields(["dealer"]),
    ...mapRegisterFields([
      "manager.firstName",
      "manager.lastName",
      "manager.dealerId",
      "manager.registeredCompanyName",
      "manager.acn",
      "manager.abn",
      "manager.city",
      "manager.address",
      "manager.state",
      "manager.postcode",
      "manager.telephoneNo",
      "manager.mobileNo",
      "manager.email",
      "manager.yrsEstablished",
      "manager.driversLicense",
      "manager.numberSubAgents",
      "manager.accountName",
      "manager.bank",
      "manager.accountNo",
      "manager.bsbno",
      "manager.branchAddress",
      "manager.dob",
      "manager.tradingName",
      "manager.yearsEstablished",
      "manager.directorsName",
      "manager.approvedDealer",
      "manager.electronicSignature",
      "message",
    ]),
    ...mapOutputFields({
      outputMessage: "message",
    }),
    items() {
      return this.entries;
    },
  },
  mounted() {
    // this.$validator.localize("en", this.dictionary);

    this.getRegistered()
      .then(() => {})
      .catch(() => {});
  },
  watch: {
    search(val) {
      let vm = this;

      if (val.length > 5)
        vm.searchAddress(val)
          .then((res) => {
            vm.entries = res;
          })
          .catch(() => {})
          .finally(() => (vm.isLoading = false));
    },
  },
};
</script>

<style scoped></style>
